import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BannerStateService {
  private currentBannerId: number;
  private readonly availableBannerIds = [1, 2, 3];

  constructor() {
    this.currentBannerId = this.getRandomBannerId();
  }

  shouldShowBanner(bannerId: number): boolean {
    return this.currentBannerId === bannerId;
  }

  private getRandomBannerId(): number {
    const randomIndex = Math.floor(Math.random() * this.availableBannerIds.length);
    return this.availableBannerIds[randomIndex];
  }
}
